import React, { Component, createRef } from 'react';

interface IDropDownProps {
    active: boolean;
    children: React.ReactNode;
    dropdownId: string;
    label: string | React.ReactText;
}

interface IDropDownState {
    isOpen: boolean;
}

export class DropDown extends Component<IDropDownProps, IDropDownState> {
    dropdownMenuRef = createRef<HTMLDivElement>();

    constructor(props: IDropDownProps) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    handleClick = (e: MouseEvent) => {
        const dropdownMenu = this.dropdownMenuRef.current;
        const target = e.target;

        if (!dropdownMenu) return;
        if (target instanceof Node && dropdownMenu.contains(target)) {
            return; // inside click
        }
        // outside click
        this.setState({ isOpen: false });
    };

    componentDidMount() {
        window.addEventListener('click', this.handleClick);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.handleClick);
    }

    handleClose = () => {
        this.setState({ isOpen: false });
    };

    render() {
        return (
            <div className="dropdown" ref={this.dropdownMenuRef}>
                <button
                    id={this.props.dropdownId}
                    onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ isOpen: !this.state.isOpen });
                    }}
                    className={
                        'btn-dropdown' +
                        (this.props.active ? ' active' : ' border')
                    }
                    type="button"
                    aria-haspopup="true"
                    aria-expanded={this.state.isOpen}
                >
                    {this.props.label}
                </button>
                <div
                    className={
                        'dropdown-menu' + (this.state.isOpen ? ' show' : '')
                    }
                    aria-labelledby={this.props.dropdownId}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}
